import { fetchWithRetry } from './utils';
import config from './config';

/**
 * 获取当前用户信息
 * @param {string} email - 用户邮箱
 * @returns {Promise}
 */
export const getUserInfo = (email) => {
  return fetchWithRetry(
    `${config.API_PATHS.BASE_API_URL}/users/me?email=${encodeURIComponent(email)}`,
    {
      method: 'GET',
    }
  );
};

/**
 * 更新用户信息
 * @param {string} email - 用户邮箱
 * @param {Object} data - 用户信息数据
 * @param {string} data.username - 用户名
 * @returns {Promise}
 */
export const updateUserInfo = (email, data) => {
  return fetchWithRetry(
    `${config.API_PATHS.BASE_API_URL}/users/me?email=${encodeURIComponent(email)}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }
  );
};

/**
 * 获取用户列表（管理员）
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.page_size - 每页数量
 * @param {string} params.search - 搜索关键词
 * @returns {Promise}
 */
export const getUserList = (params) => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append('page', params.page);
  if (params.page_size) queryParams.append('page_size', params.page_size);
  if (params.search) queryParams.append('search', params.search);

  return fetchWithRetry(
    `${config.API_PATHS.BASE_API_URL}/users/list?${queryParams.toString()}`,
    {
      method: 'GET',
    }
  );
};

